import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

@Injectable()
export class CheckDateService {
private dateStartIssue;
private dateEndIssue;

constructor() { }

/**
   * Verifica che la data iniziale non sia successiva a quella finale
   * @param dateStart
   * @param dateEnd
   */
  checkStartDate(dateStart, dateEnd) {
    let dateEndMin = dateStart.value || undefined;
    if (dateEnd.value && dateStart.value && dateStart.value > dateEnd.value) {
      this.dateStartIssue = true;
    } else {
      this.dateStartIssue = false;
    }
    return Observable.of({dateEndMin, dateStartIssue: this.dateStartIssue});
  }

  /**
   * Verifica che la data finale non sia precedente a quella iniziale
   * @param dateStart
   * @param dateEnd
   */
  checkEndDate(dateStart, dateEnd) {
    let dateStartMax = dateEnd.value || undefined;
    if (dateStart.value && dateEnd.value && dateEnd.value < dateStart.value) {
      this.dateEndIssue = true;
    } else {
      this.dateEndIssue = false;
    }
    return Observable.of({dateStartMax, dateEndIssue: this.dateEndIssue});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/check-date/check-date.service.ts